import { Fragment, useEffect, useState } from "react";
import { Phone, User, File, Mail } from "react-feather";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Container, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import { CSS } from "src/_utils/styles";
import { getCountryCode } from "src/_utils/validations";
import EBSSSButton from "src/base/atoms/EBSSSButton";
import EBSSSTooltip from "src/base/atoms/EBSSSTooltip";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import FeedbackMessages from "src/base/FeedbackMessage";
import Page from "src/base/Page";
import { cleanErrorsAndMessages, Session } from "src/base/store/authSlice";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { ReduxDataKey } from "src/base/store/store";
import { InputType } from "reactstrap/types/lib/Input";
import { Email } from "src/Constant";
import { useFormValidation } from "src/base/hooks/form_validator_handler";
import { toast } from "react-toastify";

const InputTemplate = ({ id, label, nameAttribute, data, setData, typeInput = "text", icon, messages }) => {
  return typeInput === "textarea" ? (
    <div className="col-sm-12">
      <FormGroup>
        <Label>{label}</Label>
        <textarea
          seller-recognization="true"
          id={id}
          rows={3}
          name={id}
          className="form-control"
          defaultValue={data[nameAttribute]}
          onChange={(event) => setData({ ...data, [nameAttribute]: event.target.value })}
        ></textarea>
        <div id={`invalid-${id}-feedback`}></div>
        <FeedbackMessages messages={messages} />
      </FormGroup>
    </div>
  ) : (
    <div className="col-sm-12">
      <FormGroup>
        <Label>{label}</Label>
        <InputGroup>
          <InputGroupText>{icon}</InputGroupText>
          <Input
            seller-recognization="true"
            id={id}
            name={id}
            type={typeInput as InputType}
            defaultValue={data[nameAttribute]}
            onChange={(event) =>
              setData({
                ...data,
                [nameAttribute]: event.target.value,
              })
            }
          />
        </InputGroup>
        <div id={`invalid-${id}-feedback`}></div>
        <FeedbackMessages messages={messages} />
      </FormGroup>
    </div>
  );
};

const ContainerUserData = ({ data, setData, handleSubmit, apiErrors }) => {
  const { trans } = useEBSSSLayout();

  return (
    <Fragment>
      <Col xl="12" lg="12" md="12" className="xl-65">
        <Row className="row">
          <Col sm="12">
            <Card>
              <div className="form-post">
                <div className="post-body">
                  <Form className="theme-form login-form bg-transparent text-muted">
                    <div className="row">
                      <InputTemplate
                        id="company_name"
                        icon={<User />}
                        label={trans("website.seller-company-name") + ": *"}
                        nameAttribute="company_name"
                        data={data}
                        setData={setData}
                        messages={apiErrors?.company_name}
                      />

                      <InputTemplate
                        id="billing_name"
                        icon={<User />}
                        label={trans("website.seller-company-billing-name") + ": *"}
                        nameAttribute="billing_name"
                        data={data}
                        setData={setData}
                        messages={apiErrors?.billing_name}
                      />

                      <InputTemplate
                        id="vat_number"
                        icon={<User />}
                        label={trans("website.seller-company-vat-number") + ": *"}
                        nameAttribute="vat_number"
                        data={data}
                        setData={setData}
                        messages={apiErrors?.vat_number}
                      />

                      <InputTemplate
                        id="email"
                        icon={<Mail />}
                        label={trans("website.seller-company-email") + ": *"}
                        nameAttribute="email"
                        data={data}
                        setData={setData}
                        typeInput="email"
                        messages={apiErrors?.email}
                      />

                      <div className="col-sm-12">
                        <FormGroup>
                          <Label style={{ display: "flex", flexDirection: "row" }}>{trans("website.seller-company-phone")}: *</Label>
                          <InputGroup>
                            <PhoneInput
                              inputStyle={CSS({
                                width: "100%",
                                height: 45,
                                display: "flex",
                              })}
                              countrySelectorStyleProps={{
                                dropdownStyleProps: {
                                  style: CSS({
                                    zIndex: 999999,
                                  }),
                                },
                                buttonStyle: CSS({
                                  height: 45,
                                  backgroundColor: "#EFEFFD",
                                  border: 0,
                                }),
                              }}
                              name="phone"
                              className="col"
                              defaultCountry={getCountryCode()}
                              value={data.phone_number}
                              onChange={(phone) =>
                                setData({
                                  ...data,
                                  phone_number: phone.replace("+", ""),
                                })
                              }
                            />
                          </InputGroup>
                        </FormGroup>
                        <FeedbackMessages messages={apiErrors?.phone_number} />

                        <div id="invalid-phone-feedback"></div>
                      </div>

                      <InputTemplate
                        id="description"
                        icon={<Mail />}
                        label={trans("website.seller-company-description") + ": *"}
                        nameAttribute="description"
                        data={data}
                        setData={setData}
                        typeInput="textarea"
                        messages={apiErrors?.description}
                      />

                      {/* <div className="col-sm-12">
                        <FormGroup>
                          <Label>{trans("website.seller-company-proof")}</Label>
                          <InputGroup>
                            <InputGroupText>
                              <File />
                            </InputGroupText>
                            <Input
                              id="proof"
                              type="file"
                              name="file"
                              required
                              defaultValue={data.proof}
                              placeholder={trans("website.seller-company-proof")}
                              className="form-control"
                              onChange={(event) => {
                                setData({
                                  ...data,
                                  proof: event.target.files[0],
                                });
                              }}
                            />
                          </InputGroup>
                          <div id="invalid-proof-feedback"></div>
                        </FormGroup>
                      </div> */}
                    </div>
                    <FormGroup>
                      <EBSSSButton onClick={handleSubmit}>Guardar</EBSSSButton>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Col>
    </Fragment>
  );
};

const SellerRecognizationPage = () => {
  const { trans } = useEBSSSLayout();
  const [formValidation] = useFormValidation(trans, "name", "border-danger", "border-success");
  const { saveSellerRecognization, apiErrors } = useEBSSS();
  const dispatcher = useDispatch<any>();

  const initialStateSellerRecognization = {
    company_name: "",
    billing_name: "",
    vat_number: "",
    email: "",
    phone_number: "",
    proof: null,
    description: "",
  };

  const [data, setData] = useState({ ...initialStateSellerRecognization });

  const handleSubmitProfile = async (e) => {
    e.preventDefault();

    window["VALIDATION_SUCCESS"] = true;

    formValidation([
      {
        inputIdentifier: "company_name",
        feedbackElement: "company_name-feedback",
        rules: {
          required: true,
          between: "0-100",
        },
      },
      {
        inputIdentifier: "billing_name",
        feedbackElement: "billing_name-feedback",
        rules: {
          required: true,
          between: "0-100",
        },
      },
      {
        inputIdentifier: "email",
        feedbackElement: "email-feedback",
        rules: {
          required: true,
          email: true,
          between: "0-80",
        },
      },
      {
        inputIdentifier: "vat_number",
        feedbackElement: "vat_number-feedback",
        rules: {
          required: true,
          between: "0-15",
        },
      },
      {
        inputIdentifier: "description",
        feedbackElement: "description-feedback",
        rules: {
          between: "0-100",
        },
      },
    ]);

    if (data.phone_number.length < 9) {
      document.querySelector("#invalid-phone-feedback").textContent = trans("common.required");
      document.querySelector("#invalid-phone-feedback").classList.add("invalid-feedback", "mb-3", "d-block");
      document.querySelector("#invalid-phone-feedback").classList.remove("d-none");
      document.querySelector('[name="phone"]').classList.remove("border-success");
      document.querySelector('[name="phone"]').classList.add("border-danger");
      window["VALIDATION_SUCCESS"] = false;
    } else {
      document.querySelector("#invalid-phone-feedback").classList.remove("invalid-feedback", "mb-3", "d-block");
      document.querySelector("#invalid-phone-feedback").classList.add("d-none");
      document.querySelector('[name="phone"]').classList.remove("border-danger");
      document.querySelector('[name="phone"]').classList.add("border-success");
    }

    if (!window["VALIDATION_SUCCESS"]) {
      return;
    }

    const responseSellerRecognization = await saveSellerRecognization(data);

    console.log(responseSellerRecognization);
    if (responseSellerRecognization?.seller_recognization) {
      document.querySelectorAll('[seller-recognization="true"]').forEach((el) => (el["value"] = ""));
      setData({ ...initialStateSellerRecognization });
      toast("Dados enviados com sucesso!", {
        type: "success",
      });
    }
  };

  useEffect(() => {
    dispatcher(cleanErrorsAndMessages());
  }, []);

  return (
    <Page breads={[{ name: "Reconhecimendo do Vendedor", active: true }]}>
      <Container fluid={true}>
        <div className="seller-recognization">
          <Row>
            <ContainerUserData data={data} setData={setData} handleSubmit={(e) => handleSubmitProfile(e)} apiErrors={apiErrors} />
          </Row>
        </div>
      </Container>
    </Page>
  );
};

export default SellerRecognizationPage;
